// app/javascript/controllers/driving_school_program_selection_list_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hiddenInPersonProgram", "hiddenRemoteProgram", "inPersonToggleButton", "remoteToggleButton"]

  connect() {
    this.updateButtonText()
  }

  toggleInPerson() {
    this.hiddenInPersonProgramTargets.forEach(program => {
      program.classList.toggle("u-hidden")
    })
    this.updateInPersonButtonText()
  }

  toggleRemote() {
    this.hiddenRemoteProgramTargets.forEach(program => {
      program.classList.toggle("u-hidden")
    })
    this.updateRemoteButtonText()
  }

  updateButtonText() {
    this.updateInPersonButtonText()
    this.updateRemoteButtonText()
  }

  updateInPersonButtonText() {
    if (!this.hasInPersonToggleButtonTarget) return
    
    const isHidden = this.hiddenInPersonProgramTargets.some(program => 
      program.classList.contains("u-hidden")
    )
    this.inPersonToggleButtonTarget.textContent = isHidden 
      ? "Show more in-person" 
      : "Show fewer in-person"
  }

  updateRemoteButtonText() {
    if (!this.hasRemoteToggleButtonTarget) return
    
    const isHidden = this.hiddenRemoteProgramTargets.some(program => 
      program.classList.contains("u-hidden")
    )
    this.remoteToggleButtonTarget.textContent = isHidden 
      ? "Show more remote" 
      : "Show fewer remote"
  }
}